import api from "!../../Membership/AngularApps/MemberApplication/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../Membership/AngularApps/MemberApplication/node_modules/css-loader/dist/cjs.js??ref--13-1!../../Membership/AngularApps/MemberApplication/node_modules/postcss-loader/dist/cjs.js??ref--13-2!../../Membership/AngularApps/MemberApplication/node_modules/resolve-url-loader/index.js??ref--13-3!../../Membership/AngularApps/MemberApplication/node_modules/sass-loader/dist/cjs.js??ref--13-4!./base-lite.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};